import { BreadType } from 'types/bread'
import { useEffect, useState } from 'react'
import { StockType, StockUnionType } from 'types/stock'
import { FirebaseDocRefType } from 'firebase/index'
import { dateToString } from 'lib/helper'

const useQueryPrevStocks = (
  bread: BreadType | undefined,
  date: Date,
  storeRef: FirebaseDocRefType,
  type: StockUnionType
): StockType[] => {
  const [stocks, setStockList] = useState<StockType[]>([])
  useEffect(() => {
    ;(async () => {
      if (!bread) return
      const _stocks: StockType[] = []
      await storeRef
        .collection('store_stocks')
        .where('date', '==', dateToString(date))
        .where('type', '==', type)
        .where('bread_ref', '==', bread.bread_ref)
        .get()
        .then((snapshots) => {
          snapshots.forEach((snapshot) => {
            const data = snapshot.data() as StockType
            data.stock_ref = snapshot.ref
            _stocks.push(data)
          })
        })
      setStockList([..._stocks])
    })()
  }, [bread, date, storeRef, type])
  return stocks
}

export default useQueryPrevStocks
